var path = './assets/partials/typeahead/typeahead_match.html';
var html = "<a tabindex=\"-1\" ng-bind-html=\"match.label | typeaheadHighlight:query\"></a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;